var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.485 12.707c-3.706 0-6.871.56-6.871 2.804 0 2.245 3.145 2.825 6.871 2.825 3.707 0 6.871-.561 6.871-2.804 0-2.244-3.144-2.825-6.87-2.825ZM7.485 9.506A4.404 4.404 0 1 0 3.081 5.1a4.39 4.39 0 0 0 4.373 4.405h.031Z",
    stroke: "#0D3A80",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgUser;